import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class AboutContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
            
             

            <div class="section-full p-t80 p-b0 bg-white">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-5 col-md-8 m-b30">
                            <div class=" ">
                                <img src={this.props.content[4].image} alt="" class="img-responsive" />
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-12 m-b0">
                            <div class="section-head text-left">
                                <h2 class="text-uppercase">INTRODUCTION</h2>
                                <div class="wt-separator-outer">
                                    <div class="wt-separator style-square">
                                        <span class="separator-left site-bg-primary"></span>
                                        <span class="separator-right site-bg-primary"></span>
                                    </div>
                                </div>
                                <div  dangerouslySetInnerHTML={{ __html: this.props.content[4].description}} />  
                            </div>
                            
                        </div>
						
                    </div>
					
					<div class="row">
                        
                        <div class="col-lg-7 col-md-12 m-b0">
                            <div class="section-head text-left">
                               
                                
                                <h5>{this.props.content[5].title}</h5><br />
                              <div  dangerouslySetInnerHTML={{ __html: this.props.content[5].description}} />  
                               
								 </div>
                            
                        </div>
						<div class="col-lg-5 col-md-8 m-b3">
                            <div class=" ">
                                <img src={this.props.content[5].image} alt="" class="img-responsive" />
                            </div>
                        </div>
                    </div>
					 
                </div>
            </div> 
  
        </div>
       

    );
 
    }
}

export default AboutContent;